import Repository, { baseURL } from "./Repository";

import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

export const getNews = createAsyncThunk('Articles',async(data) =>{
  
  return await Repository.post(`${baseURL}/Articles?from=${data}`)
  .then(res => {
    return res.data
  }).catch(error =>{
            toast.error(error.response.data )
   
  })
  
}) 

export const getNew = createAsyncThunk('Article',async(data) =>{
  return await Repository.post(`${baseURL}/ArticleId?id=${data}`)
  .then(res => {
    return res.data
  }).catch(error =>{
            toast.error(error.response.data )
   
  })
  
}) 

export const getCommentsOfNew = createAsyncThunk('comments',async(data) =>{
  return await Repository.post(`${baseURL}/ArticleIdeas?id=${data}`)
  .then(res => {
 
    return res.data
  }).catch(error =>{
            toast.error(error.response.data )
   
  })
  
}) 



export const submitCommentsOfNew = createAsyncThunk('commentSubmit',async(data) =>{
  return await Repository.post(`${baseURL}/ArticleIdeaAdd?id=${data.id}`,{
        "Text":data.text,
        "Name":data.name,
        "Mobile":data.phone,
        "Id":data.id,
  })
  .then(res => {
    toast.success( res.data)
  }).catch(error =>{
            toast.error(error.response.data )
   
  })
  
}) 